import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import _isFunction from 'lodash/isFunction';
import _isEmpty from 'lodash/isEmpty';
import _debounce from 'lodash/debounce';
import _noop from 'lodash/noop';
import cx from 'classnames';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import SORT_ORDER from '@tekion/tekion-base/constants/sortOrder';
import PropertyControlledComponent from '../../../../molecules/PropertyControlledComponent';
import SortOrderIndicator from './SortOrderIndicator';
import style from './headerWithSortIndicator.module.scss';
var HeaderWithSortIndicator = function HeaderWithSortIndicator(props) {
  var Header = props.headerTitle,
    sortType = props.sortType,
    isRightAlign = props.isRightAlign,
    onClick = props.onClick,
    sortSequence = props.sortSequence;
  var clickCount = useRef(0);
  var callbackHandler = function callbackHandler() {
    onClick(clickCount.current);
    clickCount.current = 0;
  };
  var debouncedOnClickHandler = _debounce(callbackHandler, 250);
  var onClickHandler = function onClickHandler() {
    clickCount.current += 1;
    debouncedOnClickHandler();
  };
  var shouldDisplaySortSequence = sortSequence > 0 && !_isEmpty(sortType);
  return /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    onClick: onClickHandler,
    className: cx(style.centerAlignHeader, style.noOutline, _defineProperty({}, style.rightAlign, isRightAlign))
  }, /*#__PURE__*/React.createElement("div", null, _isFunction(Header) ? /*#__PURE__*/React.createElement(Header, null) : Header), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
    controllerProperty: shouldDisplaySortSequence
  }, /*#__PURE__*/React.createElement("div", {
    className: style.sortContainer
  }, /*#__PURE__*/React.createElement("span", null, sortSequence), /*#__PURE__*/React.createElement(SortOrderIndicator, {
    sortType: sortType
  }))), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
    controllerProperty: !shouldDisplaySortSequence
  }, /*#__PURE__*/React.createElement(SortOrderIndicator, {
    sortType: sortType
  })));
};
HeaderWithSortIndicator.propTypes = {
  headerTitle: PropTypes.string,
  isRightAlign: PropTypes.bool,
  onClick: PropTypes.func,
  sortSequence: PropTypes.number,
  sortType: PropTypes.oneOf([SORT_ORDER.ASC, SORT_ORDER.DESC])
};
HeaderWithSortIndicator.defaultProps = {
  headerTitle: EMPTY_STRING,
  isRightAlign: false,
  onClick: _noop,
  sortSequence: 0,
  sortType: EMPTY_STRING
};
export default HeaderWithSortIndicator;